const getters = {
  regData: (state) => state.regData,
  customerData: (state) => state.regData.ContactData,
  firstPage: (state) => state.isFirstPage
};

export default {
  getters
};
